import {
  Box,
  Container,
  useToast,
  Wrap,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';

import { Redirect } from 'react-router-dom';
import Pagination from '../../components/Pagination';

import TemporaryTrafficManagementCostPercentage from './components/report-sections/TemporaryTrafficManagementCostPercentage';
import TemporaryTrafficManagementCostConfidence from './components/report-sections/TemporaryTrafficManagementCostConfidence';
import TemporaryTrafficManagementReportHeader from './components/report-headers/TemporaryTrafficManagementReportHeader';
import PrintablePdf from '../../components/PrintablePdf';
import DataDisclaimer from '../../components/DataDisclaimer';
import useHasAccess from '../../hooks/useHasAccess';

function TemporaryTrafficManagement() {
  const toast = useToast();
  // Check if user has any of the allowed roles for the selected RCA
  const hasAccess = useHasAccess();

  const printableRef = useRef();

  if (!hasAccess) {
    toast({
      title: 'Report Unavailable',
      description: 'Sorry the report is not available for the selected RCA',
      status: 'info',
      duration: 4000,
      isClosable: true,
    });
    return <Redirect to="/performance/dashboard" />;
  }

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Temporary Traffic Management"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                The Government Policy Statement on land transport (GPS) for 2024-34 sets expectations around more efficient and effective temporary traffic management (TTM). One requirement is that REG publicly reports on TTM costs for all road controlling authorities as part of NZTA’s Performance and Efficiency Plan.
              </Text>
              <Text mb={4}>
                REG collects TTM information for Territorial Authorities on behalf of NZTA via the Transport Insights web portal. The TTM cost information is reported quarterly to the Minister of Transport as part of the NZTA Performance and Efficiency Plan reports.
              </Text>
              <Text>
                RCA results are made available in this page once the results are approved for release by the NZTA Board and the Minister of Transport.
              </Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <TemporaryTrafficManagementReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <TemporaryTrafficManagementCostPercentage />
            <TemporaryTrafficManagementCostConfidence />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default TemporaryTrafficManagement;
